import { render } from "./IndexOld.vue?vue&type=template&id=1cbbd165&scoped=true"
import script from "./IndexOld.vue?vue&type=script&lang=js"
export * from "./IndexOld.vue?vue&type=script&lang=js"

import "./IndexOld.vue?vue&type=style&index=0&id=1cbbd165&scoped=true&lang=css"

import exportComponent from "/var/docker/processing-orders/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cbbd165"]])

export default __exports__